import { createSlice, createSelector, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Define the new state interface
export interface ImageViewStateType {
    image: string;
}

// Initial state
const initialState: ImageViewStateType = {
    image: '',
};

// Create slice
export const imageViewSlice = createSlice({
    name: 'imageView',
    initialState,
    reducers: {
        setImage: (state, action: PayloadAction<string>) => {
            state.image = action.payload;
        },
        clearImage: (state) => {
            state.image = '';
        },
    },
});

// Export actions
export const {
    setImage,
    clearImage
} = imageViewSlice.actions;

// Export reducer
export default imageViewSlice.reducer;

// Selector
export const imageViewSelector = (state: RootState) => state.imageView;

export const imageSelector = createSelector(
    [imageViewSelector],
    (state) => state.image
);
